module.exports = __webpack_public_path__ + "img/mellat.cdbdbdc3.png";